module.exports = "/images/register_bg.jpg?14a6bcf5d9da7dfe65a254e007c591d5";